import { ComingSoonSection } from "../ComingSoonSection"

export const CustomerDashboardReports = () => {
  return (
    <ComingSoonSection
      title="Reports are on the way."
      subtitle="This section will soon provide detailed performance summaries and usage insights."
    />
  )
}
